import config from '../config';
import api from '@/common/api';

// 例外が発生した場合にこのメソッドを呼ぶことで、サーバにエラー内容を保存する
// type : ファイル名など、識別するための文字
// err : エラーオブジェクト
export const error = (type, err) => {
  if (process.env.VUE_APP_ERROR_ALERT) {
    let message = err?.message ?? 'unknown error';
    if (err?.stack) {
      message = err.stack;
    }
    alert(message);
  }
  const param = {
    type,
    time: new Date().getTime(),
    reason: (err?.message ?? 'unknown error') + ', userAgent: ' + window.navigator.userAgent,
    stack: err?.stack ?? ''
  };
  post(param);
};

// unhandledrejectionが発生した場合にこのメソッドを呼び、サーバにエラー内容を保存する
// event : イベントオブジェクト
export const unhandledrejection = (event) => {
  if (process.env.VUE_APP_ERROR_ALERT) {
    alert(event?.reason ?? 'unknown error');
  }
  const param = {
    type: 'unhandledrejection',
    time: new Date().getTime(),
    reason: (event?.reason ?? 'unknown error') + ', userAgent: ' + window.navigator.userAgent,
    stack: ''
  };
  post(param);
};

// 利用者の agent 情報を保存する
// agent : window.navigation インタフェースから取得できる agent 情報
export const currentUserAgent = (agent) => {
  const param = {
    type: 'currentUserAgent',
    time: new Date().getTime(),
    reason: agent,
    stack: ''
  };
  post(param);
};

function post(param) {
  try {
    const response = api.postCall(config.ADMIN, '/frontendLogs', param);
    if (response && typeof response.catch === 'function') {
      response.catch((e) => { 
        e; // to avoid warning
        // サーバー側へログを通知する処理なので例外は無視
        //console.log('frontendLogs post failed:', e);
      });
    }
  } catch (e) {
    // サーバー側へログを通知する処理なので例外は無視
    //console.log('frontendLogs post threw synchronously:', e);
  }
}

export default {
  error,
  unhandledrejection,
  currentUserAgent
};